import React from 'react';

import { Box, Theme } from '@mui/material';

/**
 * Offset the content up so the image can be under the menu
 */
export default function HeroContainer(props) {
  return (
    <Box
      sx={{
        marginTop: (theme: Theme) => {
          return {
            xs: `-${theme.menu.mobile.height}`,
            sm: `-${theme.menu.desktop.height}`,
          };
        },
      }}
    >
      {props.children}
    </Box>
  );
}
